// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root___N3Ot","label":"LabeledBox_label__1WL0m"};